import type { Variant } from '../gameTypes.js';
import type { PianoChart } from '../pianoChart.js';
import { PALETTE_FOREST } from '../builtinPulseMaps/palettes.js';
import { buildBuiltinAudio } from '../builtinPulseMaps/audioFromOnsets.js';
import audioOnsets from '../circlesBuiltinMaps/audio/adventure.onsets.json' with { type: 'json' };
import { pianoVariantsFromSpec } from './pianoFromOnsets.js';

/**
 * Adventure — JJD (NCS). 100 BPM melodic glitch hop with a strong
 * hook. Soft mid-tier track — a comfortable stepping stone on the
 * way up the piano-lane difficulty curve.
 *
 * Synthesised from the Circles onset analysis. See the header doc
 * on {@link import('./01-on-and-on.js').ON_AND_ON_PIANO_VARIANTS}
 * for the curated-MIDI upgrade path.
 */
export const ADVENTURE_PIANO_VARIANTS: Record<Variant, PianoChart> = pianoVariantsFromSpec({
  baseSlug: 'adventure',
  baseTitle: 'Adventure',
  description:
    "JJD's melodic glitch hop. Soft mid-tier track with a strong melodic hook flowing through four lanes.",
  difficulty: 2,
  totalBeats: 103,
  palette: PALETTE_FOREST,
  audio: buildBuiltinAudio({
    src: '/audio/circles/adventure.mp3',
    attribution: '"Adventure" by JJD [NCS Release] - https://ncs.io/Adventure',
    data: audioOnsets,
  }),
  onsets: audioOnsets,
  sections: [
    {
      startBeat: 0,
      endBeat: 103,
      selectOpts: { kinds: ['lead', 'snare'], minIntensity: 0.05, minSpacing: 0.5 },
    },
  ],
});
